import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { messages as enMessages } from './locales/en/messages'
import { messages as esMessages } from './locales/es/messages'
import { messages as frMessages } from './locales/fr/messages'
import { messages as ptMessages } from './locales/pt/messages'
import './index.css'
import App from './App'

const container = document.getElementById('root')

export function getPreferredLocale(supportedLocales) {
  // Check localStorage/sessionStorage
  const storedLang = localStorage.getItem('preferredLanguage')
  if (storedLang && supportedLocales.includes(storedLang)) {
    return storedLang
  }

  // Detect browser language with fallback
  const browserLanguage = navigator.language || navigator.userLanguage;
  
  // Check full language code (e.g., 'en-US')
  if (browserLanguage && supportedLocales.includes(browserLanguage)) {
    return browserLanguage
  }

  // Check base language (e.g., 'en' from 'en-US')
  const baseLanguage = browserLanguage.split('-')[0];
  if (baseLanguage && supportedLocales.includes(baseLanguage)) {
    return baseLanguage
  }

  // Fallback to Frances
  return 'fr'
}

// i18n.load('en', enMessages)
i18n.load({
  en   : enMessages
  , es : esMessages
  , fr : frMessages
  , pt : ptMessages
})

i18n.activate(getPreferredLocale(['en', 'es', 'fr', 'pt']))

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered:', registration)
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error)
      })
  })
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <I18nProvider i18n={i18n}>
        <App />
      </I18nProvider>
    </BrowserRouter>
  </StrictMode>)
